export const classNames = (array, join = ' ') => array.filter(Boolean).join(join).trim();
export default classNames;
